import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckmarkOutlinedIcon } from '@getgo/chameleon-icons/react';
import { TooltipV2 } from '@getgo/chameleon-web/react';
import classNames from 'classnames';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { MessageDirection } from "../../state/conversation/types";
import { useDateNow } from "../../utils/hooks";
import classes from './Time.module.scss';
export const getTimeLabel = (date, now, t, showTime = true) => {
    const startDate = new Date(date).getTime();
    const total = now >= startDate ? Math.floor((now - startDate) / 1000) : 0;
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total - hours * 3600) / 60);
    const timeFormat = {
        timeStyle: 'short',
        dateStyle: undefined,
    };
    if (hours >= 24) {
        timeFormat.timeStyle = showTime ? 'short' : undefined;
    }
    return hours >= 1
        ? new Intl.DateTimeFormat(i18n.language || 'en-US', timeFormat).format(new Date(date))
        : minutes > 1
            ? t('{{minutes}} minutes ago', {
                minutes: String(minutes),
            })
            : minutes === 1
                ? t('1 minute ago')
                : t('Just now');
};
export const getFullDate = (date) => {
    const formatedDate = new Intl.DateTimeFormat(i18n.language || 'en-US', {
        timeStyle: 'short',
        dateStyle: 'short',
    })
        .format(new Date(date))
        .split(',');
    // Invert Time and Date
    return `${formatedDate[1]} ${formatedDate[0]}`;
};
/**
 * @deprecated Use ```@ucc-messaging/inbox-common-ui``` instead
 * */
const Time = ({ className, date, lastMessageReadAt, color, direction, showTime = true, displayFullDate = false, }) => {
    console.warn('Time is deprecated, use @ucc-messaging/inbox-common-ui instead');
    const { t } = useTranslation();
    const now = useDateNow();
    const isOutBound = direction === MessageDirection.OUTBOUND;
    return (_jsxs("span", Object.assign({ className: classNames(className, classes.time, isOutBound && classes.timeOutBound, lastMessageReadAt && classes.withReadIndicator) }, { children: [displayFullDate && (_jsx(TooltipV2, Object.assign({ position: "left-center", trigger: _jsx("span", { children: getTimeLabel(date, now, t, showTime) }, void 0) }, { children: getFullDate(date) }), void 0)), !displayFullDate && (_jsxs(_Fragment, { children: [getTimeLabel(date, now, t, showTime), lastMessageReadAt && (_jsx(TooltipV2, Object.assign({ position: "bottom-end", trigger: _jsx("span", Object.assign({ style: {
                                color: color ? color : 'var(--goto-icon-color-brand-default)',
                                marginLeft: 'var(--goto-spacing-01)',
                            } }, { children: _jsx(CheckmarkOutlinedIcon, {}, void 0) }), void 0) }, { children: t('Read {{dateTime}}', { dateTime: getTimeLabel(lastMessageReadAt, now, t) }) }), void 0))] }, void 0))] }), void 0));
};
export default Time;
//# sourceMappingURL=Time.js.map